import styled from 'astroturf/react';

const Checkbox = styled('div')`
  display: block;
  font-size: var(--ph-text-sm);
  color: var(--ph-gray-500);
  vertical-align: middle;
  position: relative;
  padding: 0 0 0 40px;
  margin: 0 0 5px 0;
  user-select: none;

  &[class*='removeLeftPadding']{
    padding-left: 24px;    
    width: auto;
    display: inline-block;
    margin: 0;
    span[class*='check-mark']{
      left: 0;
    }
    label{
      width: 100%;
    }
  }

  &.inline {
    display: inline;
  }

  &.disabled {
    cursor: not-allowed;

    label {
      cursor: not-allowed;

      span {
        background-color: var(--ph-gray-50);
        border: 2px solid var(--ph-gray-100);
      }
    }
  }

  &.reverse {
    display: flex;
    align-items: center;
    padding-left: 0;
  }
`;

const Checkmark = styled('span')`
  position: absolute;
  top: 0;
  left: 17px;
  height: 16px;
  width: 16px;
  border-radius: var(--ph-border-radius-xs);
  border: solid 2px var(--ph-light-blue-500);

  &.reverse {
    position: static;
  }
`;

const Input = styled('input')`
  position: absolute;
  opacity: 0 !important;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked + [class*='check-mark'] {
    &::before {
      position: absolute;
      content: '';
      top: 0;
      left: 1px;
      width: 10px;
      height: 12px;
      background:
        svg-load('../Svg/icons/checkbox.svg', fill=#29a9e0) 0 center
        no-repeat;
    }
  }

  &:checked + [class*='reverse'] {
    &::before {
      top: 10px;
      left: 3px;
    }
  }
`;

const CheckboxInputWrapper = styled('label')`
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 30px;
  cursor: pointer;

  &.reverse {
    width: 16px;
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 7px;
  }
`;

export default {
  Checkbox,
  CheckboxInputWrapper,
  Checkmark,
  Input,
};
